import { render, staticRenderFns } from "./DetailSurgeryTransfusion.vue?vue&type=template&id=3409f884&scoped=true&"
import script from "./DetailSurgeryTransfusion.vue?vue&type=script&lang=js&"
export * from "./DetailSurgeryTransfusion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3409f884",
  null
  
)

export default component.exports